/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Next_BidInputs */

const en_directory_vibebids_next_bid = /** @type {(inputs: Directory_Vibebids_Next_BidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`next bid`)
};

const zh_directory_vibebids_next_bid = /** @type {(inputs: Directory_Vibebids_Next_BidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一次出价`)
};

/**
* | output |
* | --- |
* | "next bid" |
*
* @param {Directory_Vibebids_Next_BidInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_next_bid = /** @type {((inputs?: Directory_Vibebids_Next_BidInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Next_BidInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_next_bid(inputs)
	return zh_directory_vibebids_next_bid(inputs)
});
export { directory_vibebids_next_bid as "directory.vibebids.next_bid" }